import { toJSTyped } from '../../../utils/immutable/toJSTyped';
export const getCapabilityKeyContext = capabilityKey => toJSTyped(capabilityKey.delete('capability'));